import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { get } from '../api'
import { LevelAttrs } from '../types'
import { showToast } from '../utils/toast'
import { t } from '@lingui/core/macro'

// 查询用户的vip level
export const useUserVipInfo = ({
  queryUserId,
  enable = true,
}: {
  queryUserId?: string
  enable?: boolean
} = {}) => {
  const targetUserId = queryUserId

  const { data, isFetching, refetch, error } = useQuery<{ info: LevelAttrs }>({
    queryKey: ['vipLevel', targetUserId],
    queryFn: async () => {
      try {
        const response = await get(
          '/v1/skinsyard/facade/membership/query_user_public_info',
          {
            userId: targetUserId,
          },
          {},
          false,
        )
        return response
      } catch (err) {
        console.error(err)
        throw err
      }
    },
    enabled: !!targetUserId && enable,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchInterval: false,
  })

  useEffect(() => {
    if (error) {
      showToast.error(t`Cannot reach the server.`)
      console.error(error)
    }
  }, [error])

  return {
    vipInfo: data?.info,
    loading: isFetching,
    error,
    refetch,
  }
}
